export const RESOURCE = 'adminredemptionrequestsearch';
export const ACTIONS = { Search: '/redemptionrequests' }